import { render } from "./ModalFileUploadProducts.vue?vue&type=template&id=6231e62b&scoped=true"
import script from "./ModalFileUploadProducts.vue?vue&type=script&lang=js"
export * from "./ModalFileUploadProducts.vue?vue&type=script&lang=js"

import "./ModalFileUploadProducts.vue?vue&type=style&index=0&id=6231e62b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6231e62b"]])

export default __exports__